module.exports = __webpack_public_path__ + "img/Playstore-Download.svg";